import React, { useCallback } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import { useTranslation } from 'react-i18next';
import { cardStyle } from './card.utils';
import { policyMap } from '../../constants/PolicyMap';
import Icon from '../Icon';
import { CommonStyles as CS, Color, CommonProperties } from '../../styles';
import BaseText from '../BaseText';

const PriceItem = ({
  price,
  labelUp,
  labelDown,
  isPrimary,
  iconName,
  onPress,
  disabled,
  policyReasonCode,
  secondLabel,
}) => {
  const { t } = useTranslation();
  const onPressCallback = useCallback(() => {
    if (onPress) {
      onPress();
    }
  }, [onPress]);

  return (
    <TouchableOpacity disabled={disabled} onPress={onPressCallback}>
      {policyMap[policyReasonCode] && (
        <View
          style={[
            styles.policyHeader,
            { backgroundColor: policyMap[policyReasonCode].color },
            isPrimary ? styles.boxActive : null,
          ]}
        >
          <BaseText style={styles.policyHeaderText}>
            {t(policyMap[policyReasonCode].display)}
          </BaseText>
        </View>
      )}
      <View
        style={[
          styles.box,
          isPrimary ? styles.boxActive : null,
          iconName ? null : styles.flexEnd,
          disabled ? cardStyle.disabled : null,
          policyMap[policyReasonCode] ? styles.policyBox : null,
        ]}
      >
        {iconName && (
          <Icon
            style={styles.icon}
            name={iconName}
            color={isPrimary ? Color.active : Color.primary}
          />
        )}
        <View style={styles.boxText}>
          <BaseText style={[cardStyle.medium, isPrimary && styles.textActive]}>{price}</BaseText>
          <BaseText style={[CS.xxSmall, isPrimary && styles.textActive]}>{labelUp || ' '}</BaseText>
          {secondLabel && (
            <BaseText style={[CS.xxSmall, isPrimary && styles.textActive]}>{secondLabel}</BaseText>
          )}
          <BaseText style={[CS.xxSmall, isPrimary && styles.textActive]}>
            {labelDown || ' '}
          </BaseText>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default PriceItem;

const defaultBorder = {
  borderWidth: 0.5,
  borderColor: '#939393',
};

const styles = StyleSheet.create({
  box: {
    ...defaultBorder,
    justifyContent: 'space-between',
    ...CommonProperties.row,
    ...CommonProperties.p2,
    ...CommonProperties.mb2,
    ...CommonProperties.borderRadius,
  },
  policyBox: {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    borderTopWidth: 0,
  },
  boxText: {
    alignItems: 'flex-end',
    ...CommonProperties.ml3,
  },
  flexEnd: {
    justifyContent: 'flex-end',
  },
  boxActive: {
    borderColor: Color.active,
  },
  textActive: {
    color: Color.active,
  },
  icon: {
    ...CommonProperties.mr3,
    ...CommonProperties.h2,
  },
  policyHeader: {
    ...defaultBorder,
    borderBottomWidth: 0,
    ...CommonProperties.borderTopRadius,
    ...CommonProperties.centerAlignment,
    ...CommonProperties.px2,
  },
  policyHeaderText: {
    ...CommonProperties.xSmall,
    color: 'white',
  },
});
